"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../controllers/BaseController");
var DlgApiErrorCtl = /** @class */ (function (_super) {
    __extends(DlgApiErrorCtl, _super);
    function DlgApiErrorCtl() {
        return _super.call(this, true) || this;
    }
    DlgApiErrorCtl.prototype.ResetData = function () {
        this.DATA = {
            onClose: null,
            onLogout: null,
            visible: false,
            dialogTitle: "",
            errorFatal: false,
            errorMessage: "",
            srvErrorCode: 0,
            srvErrorInfo: "",
            srvErrorReason: ""
        };
    };
    DlgApiErrorCtl.prototype.clearFields = function () {
        this.ResetData();
        this.Update();
        return this;
    };
    DlgApiErrorCtl.prototype.IsVisible = function () {
        return this.DATA.visible;
    };
    DlgApiErrorCtl.prototype.Show = function () {
        this.DATA.visible = true;
        this.Update();
        return this;
    };
    DlgApiErrorCtl.prototype.Close = function () {
        this.DATA.visible = false;
        this.Update();
        return this;
    };
    DlgApiErrorCtl.prototype.SetErrorFatal = function (fatal) {
        this.DATA.errorFatal = fatal;
        this.Update();
        return this;
    };
    DlgApiErrorCtl.prototype.SetServerParams = function (errCode, errInfo, errReason) {
        if (errCode) {
            this.DATA.srvErrorCode = errCode;
        }
        if (errInfo) {
            this.DATA.srvErrorInfo = errInfo;
        }
        if (errReason) {
            this.DATA.srvErrorReason = errReason;
        }
        this.Update();
        return this;
    };
    DlgApiErrorCtl.prototype.SetErrorMessage = function (val) {
        this.DATA.errorMessage = val;
        this.Update();
        return this;
    };
    DlgApiErrorCtl.prototype.SetDialogTitle = function (val) {
        this.DATA.dialogTitle = val;
        this.Update();
        return this;
    };
    DlgApiErrorCtl.prototype.SetOnCloseClick = function (callback) {
        this.DATA.onClose = callback;
        this.Update();
        return this;
    };
    DlgApiErrorCtl.prototype.SetOnLogoutClick = function (callback) {
        this.DATA.onLogout = callback;
        this.Update();
        return this;
    };
    DlgApiErrorCtl.prototype.ShowApiError = function (err) {
        this.SetDialogTitle("ОШИБКА API")
            .SetErrorMessage(err.error.info)
            .SetServerParams(err.error.code, err.error.info, err.error.reason)
            .Show();
    };
    return DlgApiErrorCtl;
}(BaseController_1.BaseController));
exports.DlgApiErrorCtl = DlgApiErrorCtl;



//////////////////
// WEBPACK FOOTER
// ./src/shared/dialogs/ctl/DlgApiErrorCtl.ts
// module id = 898
// module chunks = 0